export type City = {
  city: string;
  state: string;
  lat: number;
  lng: number;
};

export const cities: City[] = [
  // 🟢 TIER 1 METROS
  { city: "Delhi", state: "Delhi", lat: 28.6139, lng: 77.2090 },
  { city: "Mumbai", state: "Maharashtra", lat: 19.0760, lng: 72.8777 },
  { city: "Bangalore", state: "Karnataka", lat: 12.9716, lng: 77.5946 },
  { city: "Hyderabad", state: "Telangana", lat: 17.3850, lng: 78.4867 },
  { city: "Chennai", state: "Tamil Nadu", lat: 13.0827, lng: 80.2707 },
  { city: "Kolkata", state: "West Bengal", lat: 22.5726, lng: 88.3639 },
  { city: "Pune", state: "Maharashtra", lat: 18.5204, lng: 73.8567 },
  { city: "Ahmedabad", state: "Gujarat", lat: 23.0225, lng: 72.5714 },

  // 🟢 UTTAR PRADESH
  { city: "Lucknow", state: "Uttar Pradesh", lat: 26.8467, lng: 80.9462 },
  { city: "Kanpur", state: "Uttar Pradesh", lat: 26.4499, lng: 80.3319 },
  { city: "Noida", state: "Uttar Pradesh", lat: 28.5355, lng: 77.3910 },
  { city: "Ghaziabad", state: "Uttar Pradesh", lat: 28.6692, lng: 77.4538 },
  { city: "Meerut", state: "Uttar Pradesh", lat: 28.9845, lng: 77.7064 },
  { city: "Agra", state: "Uttar Pradesh", lat: 27.1767, lng: 78.0081 },
  { city: "Varanasi", state: "Uttar Pradesh", lat: 25.3176, lng: 82.9739 },
  { city: "Prayagraj", state: "Uttar Pradesh", lat: 25.4358, lng: 81.8463 },
  { city: "Bareilly", state: "Uttar Pradesh", lat: 28.3670, lng: 79.4304 },
  { city: "Aligarh", state: "Uttar Pradesh", lat: 27.8974, lng: 78.0880 },
  { city: "Moradabad", state: "Uttar Pradesh", lat: 28.8386, lng: 78.7733 },
  { city: "Saharanpur", state: "Uttar Pradesh", lat: 29.9670, lng: 77.5452 },
  { city: "Gorakhpur", state: "Uttar Pradesh", lat: 26.7606, lng: 83.3732 },
  { city: "Ayodhya", state: "Uttar Pradesh", lat: 26.7922, lng: 82.1998 },
  { city: "Jhansi", state: "Uttar Pradesh", lat: 25.4484, lng: 78.5685 },
  { city: "Mathura", state: "Uttar Pradesh", lat: 27.4924, lng: 77.6737 },
  { city: "Muzaffarnagar", state: "Uttar Pradesh", lat: 29.4727, lng: 77.7085 },
  { city: "Firozabad", state: "Uttar Pradesh", lat: 27.1592, lng: 78.3957 },
  { city: "Shahjahanpur", state: "Uttar Pradesh", lat: 27.8842, lng: 79.9105 },
  { city: "Rampur", state: "Uttar Pradesh", lat: 28.8159, lng: 79.0254 },
  { city: "Bulandshahr", state: "Uttar Pradesh", lat: 28.4068, lng: 77.8498 },
  { city: "Hapur", state: "Uttar Pradesh", lat: 28.7300, lng: 77.7758 },
  { city: "Etawah", state: "Uttar Pradesh", lat: 26.7855, lng: 79.0225 },
  { city: "Mainpuri", state: "Uttar Pradesh", lat: 27.2352, lng: 79.0210 },
  { city: "Sitapur", state: "Uttar Pradesh", lat: 27.5692, lng: 80.6820 },
  { city: "Hardoi", state: "Uttar Pradesh", lat: 27.3960, lng: 80.1310 },
  { city: "Lakhimpur", state: "Uttar Pradesh", lat: 27.9487, lng: 80.7811 },
  { city: "Azamgarh", state: "Uttar Pradesh", lat: 26.0670, lng: 83.1836 },
  { city: "Mirzapur", state: "Uttar Pradesh", lat: 25.1458, lng: 82.5694 },
  { city: "Deoria", state: "Uttar Pradesh", lat: 26.5020, lng: 83.7860 },
  { city: "Basti", state: "Uttar Pradesh", lat: 26.8006, lng: 82.7244 },
  { city: "Faizabad", state: "Uttar Pradesh", lat: 26.7751, lng: 82.1468 },
  { city: "Sultanpur", state: "Uttar Pradesh", lat: 26.2626, lng: 82.0727 },
  { city: "Rae Bareli", state: "Uttar Pradesh", lat: 26.2235, lng: 81.2423 },
  { city: "Unnao", state: "Uttar Pradesh", lat: 26.5442, lng: 80.4907 },
  { city: "Orai", state: "Uttar Pradesh", lat: 25.9874, lng: 79.4541 },
  { city: "Banda", state: "Uttar Pradesh", lat: 25.4770, lng: 80.3340 },
  { city: "Fatehpur", state: "Uttar Pradesh", lat: 25.9303, lng: 80.8135 },
  { city: "Pratapgarh", state: "Uttar Pradesh", lat: 25.8958, lng: 81.9943 },
  { city: "Jaunpur", state: "Uttar Pradesh", lat: 25.7464, lng: 82.6836 },
  { city: "Gonda", state: "Uttar Pradesh", lat: 27.1300, lng: 81.9600 },
  { city: "Ballia", state: "Uttar Pradesh", lat: 25.7527, lng: 84.1464 },
  { city: "Mau", state: "Uttar Pradesh", lat: 25.9424, lng: 83.5607 },
  { city: "Etah", state: "Uttar Pradesh", lat: 27.5580, lng: 78.6660 },
  { city: "Badaun", state: "Uttar Pradesh", lat: 28.0363, lng: 79.1211 },
  { city: "Pilibhit", state: "Uttar Pradesh", lat: 28.6312, lng: 79.8039 },
  { city: "Bijnor", state: "Uttar Pradesh", lat: 29.3722, lng: 78.1351 },
  { city: "Amroha", state: "Uttar Pradesh", lat: 28.9043, lng: 78.4679 },
  { city: "Kasganj", state: "Uttar Pradesh", lat: 27.8112, lng: 78.6451 },
  { city: "Hathras", state: "Uttar Pradesh", lat: 27.5916, lng: 78.0519 },
  { city: "Greater Noida", state: "Uttar Pradesh", lat: 28.4744, lng: 77.5040 },

  // 🟢 MAHARASHTRA
  { city: "Nagpur", state: "Maharashtra", lat: 21.1458, lng: 79.0882 },
  { city: "Nashik", state: "Maharashtra", lat: 19.9975, lng: 73.7898 },
  { city: "Aurangabad", state: "Maharashtra", lat: 19.8762, lng: 75.3433 },
  { city: "Solapur", state: "Maharashtra", lat: 17.6599, lng: 75.9064 },
  { city: "Kolhapur", state: "Maharashtra", lat: 16.7050, lng: 74.2433 },
  { city: "Sangli", state: "Maharashtra", lat: 16.8524, lng: 74.5815 },
  { city: "Amravati", state: "Maharashtra", lat: 20.9320, lng: 77.7523 },
  { city: "Nanded", state: "Maharashtra", lat: 19.1383, lng: 77.3210 },
  { city: "Jalgaon", state: "Maharashtra", lat: 21.0077, lng: 75.5626 },
  { city: "Akola", state: "Maharashtra", lat: 20.7059, lng: 77.0082 },
  { city: "Latur", state: "Maharashtra", lat: 18.4088, lng: 76.5604 },
  { city: "Dhule", state: "Maharashtra", lat: 20.9042, lng: 74.7749 },
  { city: "Chandrapur", state: "Maharashtra", lat: 19.9615, lng: 79.2961 },
  { city: "Yavatmal", state: "Maharashtra", lat: 20.3888, lng: 78.1204 },
  { city: "Ahmednagar", state: "Maharashtra", lat: 19.0948, lng: 74.7480 },
  { city: "Satara", state: "Maharashtra", lat: 17.6805, lng: 74.0183 },
  { city: "Parbhani", state: "Maharashtra", lat: 19.2704, lng: 76.7747 },
  { city: "Bid", state: "Maharashtra", lat: 18.9872, lng: 75.7560 },
  { city: "Osmanabad", state: "Maharashtra", lat: 18.1860, lng: 76.0400 },
  { city: "Buldhana", state: "Maharashtra", lat: 20.5292, lng: 76.1842 },
  { city: "Washim", state: "Maharashtra", lat: 20.1120, lng: 77.1340 },
  { city: "Hingoli", state: "Maharashtra", lat: 19.7160, lng: 77.1490 },
  { city: "Gondia", state: "Maharashtra", lat: 21.4620, lng: 80.1970 },
  { city: "Gadchiroli", state: "Maharashtra", lat: 20.1809, lng: 80.0000 },
  { city: "Wardha", state: "Maharashtra", lat: 20.7453, lng: 78.5987 },
  { city: "Bhandara", state: "Maharashtra", lat: 21.1620, lng: 79.6500 },
  { city: "Ratnagiri", state: "Maharashtra", lat: 16.9944, lng: 73.3003 },
  { city: "Sindhudurg", state: "Maharashtra", lat: 16.3500, lng: 73.7330 },
  { city: "Raigad", state: "Maharashtra", lat: 18.5140, lng: 73.1180 },
  { city: "Thane", state: "Maharashtra", lat: 19.2183, lng: 72.9781 },
  { city: "Navi Mumbai", state: "Maharashtra", lat: 19.0330, lng: 73.0297 },
  { city: "Palghar", state: "Maharashtra", lat: 19.6967, lng: 72.7659 },

  // 🟢 GUJARAT
  { city: "Surat", state: "Gujarat", lat: 21.1702, lng: 72.8311 },
  { city: "Vadodara", state: "Gujarat", lat: 22.3072, lng: 73.1812 },
  { city: "Rajkot", state: "Gujarat", lat: 22.3039, lng: 70.8022 },
  { city: "Bhavnagar", state: "Gujarat", lat: 21.7645, lng: 72.1519 },
  { city: "Jamnagar", state: "Gujarat", lat: 22.4707, lng: 70.0577 },
  { city: "Gandhinagar", state: "Gujarat", lat: 23.2156, lng: 72.6369 },
  { city: "Junagadh", state: "Gujarat", lat: 21.5222, lng: 70.4579 },
  { city: "Anand", state: "Gujarat", lat: 22.5645, lng: 72.9289 },
  { city: "Mehsana", state: "Gujarat", lat: 23.5880, lng: 72.3693 },
  { city: "Surendranagar", state: "Gujarat", lat: 22.7270, lng: 71.6480 },
  { city: "Bharuch", state: "Gujarat", lat: 21.7051, lng: 72.9959 },
  { city: "Navsari", state: "Gujarat", lat: 20.9467, lng: 72.9520 },
  { city: "Valsad", state: "Gujarat", lat: 20.5992, lng: 72.9342 },
  { city: "Morbi", state: "Gujarat", lat: 22.8173, lng: 70.8370 },
  { city: "Kutch", state: "Gujarat", lat: 23.7337, lng: 69.8597 },
  { city: "Bhuj", state: "Gujarat", lat: 23.2420, lng: 69.6669 },
  { city: "Amreli", state: "Gujarat", lat: 21.6021, lng: 71.2213 },
  { city: "Porbandar", state: "Gujarat", lat: 21.6418, lng: 69.6293 },
  { city: "Patan", state: "Gujarat", lat: 23.8493, lng: 72.1266 },
  { city: "Dahod", state: "Gujarat", lat: 22.8365, lng: 74.2560 },
  { city: "Kheda", state: "Gujarat", lat: 22.7490, lng: 72.6850 },
  { city: "Sabarkantha", state: "Gujarat", lat: 23.5800, lng: 73.0200 },
  { city: "Banaskantha", state: "Gujarat", lat: 24.1700, lng: 72.4350 },
  { city: "Aravalli", state: "Gujarat", lat: 23.5500, lng: 73.2100 },

  // 🟢 RAJASTHAN
  { city: "Jaipur", state: "Rajasthan", lat: 26.9124, lng: 75.7873 },
  { city: "Jodhpur", state: "Rajasthan", lat: 26.2389, lng: 73.0243 },
  { city: "Udaipur", state: "Rajasthan", lat: 24.5854, lng: 73.7125 },
  { city: "Ajmer", state: "Rajasthan", lat: 26.4499, lng: 74.6399 },
  { city: "Kota", state: "Rajasthan", lat: 25.2138, lng: 75.8648 },
  { city: "Bikaner", state: "Rajasthan", lat: 28.0229, lng: 73.3119 },
  { city: "Bhilwara", state: "Rajasthan", lat: 25.3463, lng: 74.6363 },
  { city: "Alwar", state: "Rajasthan", lat: 27.5530, lng: 76.6346 },
  { city: "Sikar", state: "Rajasthan", lat: 27.6094, lng: 75.1398 },
  { city: "Bharatpur", state: "Rajasthan", lat: 27.2152, lng: 77.4930 },
  { city: "Ganganagar", state: "Rajasthan", lat: 29.9167, lng: 73.8767 },
  { city: "Hanumangarh", state: "Rajasthan", lat: 29.5820, lng: 74.3290 },
  { city: "Nagaur", state: "Rajasthan", lat: 27.2027, lng: 73.7345 },
  { city: "Tonk", state: "Rajasthan", lat: 26.1671, lng: 75.7885 },
  { city: "Sawai Madhopur", state: "Rajasthan", lat: 26.0140, lng: 76.3530 },
  { city: "Dausa", state: "Rajasthan", lat: 26.8900, lng: 76.3310 },
  { city: "Jhunjhunu", state: "Rajasthan", lat: 28.1290, lng: 75.3960 },
  { city: "Churu", state: "Rajasthan", lat: 28.3020, lng: 74.9670 },
  { city: "Barmer", state: "Rajasthan", lat: 25.7500, lng: 71.4000 },
  { city: "Jaisalmer", state: "Rajasthan", lat: 26.9157, lng: 70.9083 },
  { city: "Pali", state: "Rajasthan", lat: 25.7711, lng: 73.3234 },
  { city: "Sirohi", state: "Rajasthan", lat: 24.8850, lng: 72.8610 },
  { city: "Jalor", state: "Rajasthan", lat: 25.3450, lng: 72.6140 },
  { city: "Dungarpur", state: "Rajasthan", lat: 23.8440, lng: 73.7130 },
  { city: "Banswara", state: "Rajasthan", lat: 23.5440, lng: 74.4400 },
  { city: "Chittorgarh", state: "Rajasthan", lat: 24.8887, lng: 74.6269 },
  { city: "Rajsamand", state: "Rajasthan", lat: 25.0700, lng: 73.8800 },
  { city: "Bundi", state: "Rajasthan", lat: 25.4470, lng: 75.6410 },
  { city: "Baran", state: "Rajasthan", lat: 25.1040, lng: 76.5180 },
  { city: "Jhalawar", state: "Rajasthan", lat: 24.5980, lng: 76.1570 },
  { city: "Karauli", state: "Rajasthan", lat: 26.5060, lng: 77.0210 },
  { city: "Dholpur", state: "Rajasthan", lat: 26.7010, lng: 77.8940 },

  // 🟢 MADHYA PRADESH
  { city: "Indore", state: "Madhya Pradesh", lat: 22.7196, lng: 75.8577 },
  { city: "Bhopal", state: "Madhya Pradesh", lat: 23.2599, lng: 77.4126 },
  { city: "Gwalior", state: "Madhya Pradesh", lat: 26.2183, lng: 78.1828 },
  { city: "Jabalpur", state: "Madhya Pradesh", lat: 23.1815, lng: 79.9864 },
  { city: "Ujjain", state: "Madhya Pradesh", lat: 23.1765, lng: 75.7885 },
  { city: "Sagar", state: "Madhya Pradesh", lat: 23.8388, lng: 78.7378 },
  { city: "Ratlam", state: "Madhya Pradesh", lat: 23.3315, lng: 75.0367 },
  { city: "Rewa", state: "Madhya Pradesh", lat: 24.5373, lng: 81.2951 },
  { city: "Satna", state: "Madhya Pradesh", lat: 24.5930, lng: 80.8320 },
  { city: "Dewas", state: "Madhya Pradesh", lat: 22.9623, lng: 76.0508 },
  { city: "Murwara", state: "Madhya Pradesh", lat: 23.8404, lng: 80.3956 },
  { city: "Morena", state: "Madhya Pradesh", lat: 26.4945, lng: 77.9996 },
  { city: "Chhindwara", state: "Madhya Pradesh", lat: 22.0574, lng: 78.9382 },
  { city: "Singrauli", state: "Madhya Pradesh", lat: 24.1997, lng: 82.6752 },
  { city: "Vidisha", state: "Madhya Pradesh", lat: 23.5251, lng: 77.8161 },
  { city: "Hoshangabad", state: "Madhya Pradesh", lat: 22.7492, lng: 77.7270 },
  { city: "Mandsaur", state: "Madhya Pradesh", lat: 24.0731, lng: 75.0681 },
  { city: "Neemuch", state: "Madhya Pradesh", lat: 24.4760, lng: 74.8690 },
  { city: "Bhind", state: "Madhya Pradesh", lat: 26.5640, lng: 78.7880 },
  { city: "Damoh", state: "Madhya Pradesh", lat: 23.8330, lng: 79.4410 },
  { city: "Shajapur", state: "Madhya Pradesh", lat: 23.4270, lng: 76.2770 },
  { city: "Shivpuri", state: "Madhya Pradesh", lat: 25.4235, lng: 77.6584 },
  { city: "Guna", state: "Madhya Pradesh", lat: 24.6510, lng: 77.3150 },
  { city: "Ashoknagar", state: "Madhya Pradesh", lat: 24.5730, lng: 77.7220 },
  { city: "Tikamgarh", state: "Madhya Pradesh", lat: 24.7430, lng: 78.8310 },
  { city: "Chhatarpur", state: "Madhya Pradesh", lat: 24.9160, lng: 79.5870 },
  { city: "Panna", state: "Madhya Pradesh", lat: 24.7180, lng: 80.1860 },
  { city: "Umaria", state: "Madhya Pradesh", lat: 23.5250, lng: 80.8410 },
  { city: "Shahdol", state: "Madhya Pradesh", lat: 23.2970, lng: 81.3500 },
  { city: "Anuppur", state: "Madhya Pradesh", lat: 23.1040, lng: 81.6920 },
  { city: "Dindori", state: "Madhya Pradesh", lat: 22.9460, lng: 81.0790 },
  { city: "Mandla", state: "Madhya Pradesh", lat: 22.5990, lng: 80.3750 },
  { city: "Seoni", state: "Madhya Pradesh", lat: 22.0860, lng: 79.5440 },
  { city: "Balaghat", state: "Madhya Pradesh", lat: 21.8130, lng: 80.1850 },
  { city: "Narsinghpur", state: "Madhya Pradesh", lat: 22.9460, lng: 79.1940 },
  { city: "Raisen", state: "Madhya Pradesh", lat: 23.3310, lng: 77.7870 },
  { city: "Betul", state: "Madhya Pradesh", lat: 21.9090, lng: 77.9030 },
  { city: "Harda", state: "Madhya Pradesh", lat: 22.3380, lng: 77.0890 },
  { city: "Khandwa", state: "Madhya Pradesh", lat: 21.8270, lng: 76.3530 },
  { city: "Burhanpur", state: "Madhya Pradesh", lat: 21.3090, lng: 76.2270 },
  { city: "Khargone", state: "Madhya Pradesh", lat: 21.8240, lng: 75.6170 },
  { city: "Barwani", state: "Madhya Pradesh", lat: 22.0340, lng: 74.9060 },
  { city: "Dhar", state: "Madhya Pradesh", lat: 22.5980, lng: 75.2970 },
  { city: "Alirajpur", state: "Madhya Pradesh", lat: 22.3090, lng: 74.3540 },
  { city: "Jhabua", state: "Madhya Pradesh", lat: 22.7660, lng: 74.5920 },
  { city: "Agar Malwa", state: "Madhya Pradesh", lat: 23.7110, lng: 76.0180 },

  // 🟢 BIHAR & JHARKHAND
  { city: "Patna", state: "Bihar", lat: 25.5941, lng: 85.1376 },
  { city: "Gaya", state: "Bihar", lat: 24.7914, lng: 85.0002 },
  { city: "Bhagalpur", state: "Bihar", lat: 25.2425, lng: 87.0151 },
  { city: "Muzaffarpur", state: "Bihar", lat: 26.1209, lng: 85.3647 },
  { city: "Darbhanga", state: "Bihar", lat: 26.1542, lng: 85.8918 },
  { city: "Purnia", state: "Bihar", lat: 25.7771, lng: 87.4753 },
  { city: "Arrah", state: "Bihar", lat: 25.5562, lng: 84.6630 },
  { city: "Begusarai", state: "Bihar", lat: 25.4182, lng: 86.1272 },
  { city: "Katihar", state: "Bihar", lat: 25.5386, lng: 87.5731 },
  { city: "Munger", state: "Bihar", lat: 25.3744, lng: 86.4733 },
  { city: "Chapra", state: "Bihar", lat: 25.7741, lng: 84.7474 },
  { city: "Samastipur", state: "Bihar", lat: 25.8613, lng: 85.7780 },
  { city: "Hajipur", state: "Bihar", lat: 25.6836, lng: 85.2089 },
  { city: "Supaul", state: "Bihar", lat: 26.1210, lng: 86.5990 },
  { city: "Madhepura", state: "Bihar", lat: 25.9190, lng: 86.7820 },
  { city: "Saharsa", state: "Bihar", lat: 25.8820, lng: 86.5970 },
  { city: "Sitamarhi", state: "Bihar", lat: 26.5910, lng: 85.4780 },
  { city: "Sheohar", state: "Bihar", lat: 26.5200, lng: 85.3000 },
  { city: "Madhubani", state: "Bihar", lat: 26.3530, lng: 86.0720 },
  { city: "Motihari", state: "Bihar", lat: 26.6540, lng: 84.9170 },
  { city: "Bettiah", state: "Bihar", lat: 26.8040, lng: 84.5030 },
  { city: "Siwan", state: "Bihar", lat: 26.2200, lng: 84.3540 },
  { city: "Gopalganj", state: "Bihar", lat: 26.4650, lng: 84.4360 },
  { city: "Saran", state: "Bihar", lat: 25.9180, lng: 84.9260 },
  { city: "Vaishali", state: "Bihar", lat: 25.7000, lng: 85.2000 },
  { city: "Nalanda", state: "Bihar", lat: 25.1360, lng: 85.4440 },
  { city: "Nawada", state: "Bihar", lat: 24.8870, lng: 85.5420 },
  { city: "Aurangabad", state: "Bihar", lat: 24.7520, lng: 84.3740 },
  { city: "Rohtas", state: "Bihar", lat: 24.9880, lng: 83.7900 },
  { city: "Buxar", state: "Bihar", lat: 25.5660, lng: 83.9820 },
  { city: "Kaimur", state: "Bihar", lat: 25.0500, lng: 83.6000 },
  { city: "Jehanabad", state: "Bihar", lat: 25.2140, lng: 84.9920 },
  { city: "Arwal", state: "Bihar", lat: 25.2520, lng: 84.6810 },
  { city: "Lakhisarai", state: "Bihar", lat: 25.1560, lng: 86.0920 },
  { city: "Sheikhpura", state: "Bihar", lat: 25.1420, lng: 85.8500 },
  { city: "Jamui", state: "Bihar", lat: 24.9260, lng: 86.2230 },
  { city: "Banka", state: "Bihar", lat: 24.8830, lng: 86.9200 },
  { city: "Khagaria", state: "Bihar", lat: 25.5020, lng: 86.4680 },
  { city: "Ranchi", state: "Jharkhand", lat: 23.3441, lng: 85.3096 },
  { city: "Jamshedpur", state: "Jharkhand", lat: 22.8046, lng: 86.2029 },
  { city: "Dhanbad", state: "Jharkhand", lat: 23.7957, lng: 86.4304 },
  { city: "Bokaro", state: "Jharkhand", lat: 23.6693, lng: 86.1511 },
  { city: "Deoghar", state: "Jharkhand", lat: 24.4853, lng: 86.6950 },
  { city: "Hazaribagh", state: "Jharkhand", lat: 23.9925, lng: 85.3612 },
  { city: "Giridih", state: "Jharkhand", lat: 24.1880, lng: 86.3060 },
  { city: "Ramgarh", state: "Jharkhand", lat: 23.6340, lng: 85.5120 },
  { city: "Pakur", state: "Jharkhand", lat: 24.6340, lng: 87.8450 },
  { city: "Sahibganj", state: "Jharkhand", lat: 25.2420, lng: 87.6370 },
  { city: "Godda", state: "Jharkhand", lat: 24.8280, lng: 87.2120 },
  { city: "Dumka", state: "Jharkhand", lat: 24.2680, lng: 87.2490 },
  { city: "Jamtara", state: "Jharkhand", lat: 23.9650, lng: 86.8020 },
  { city: "Koderma", state: "Jharkhand", lat: 24.4640, lng: 85.5970 },
  { city: "Chatra", state: "Jharkhand", lat: 24.2080, lng: 84.8750 },
  { city: "Latehar", state: "Jharkhand", lat: 23.7440, lng: 84.5050 },
  { city: "Garhwa", state: "Jharkhand", lat: 24.1680, lng: 83.8140 },
  { city: "Palamu", state: "Jharkhand", lat: 24.0300, lng: 84.0730 },
  { city: "Lohardaga", state: "Jharkhand", lat: 23.4380, lng: 84.6830 },
  { city: "Gumla", state: "Jharkhand", lat: 23.0420, lng: 84.5320 },
  { city: "Simdega", state: "Jharkhand", lat: 22.6120, lng: 84.5120 },
  { city: "West Singhbhum", state: "Jharkhand", lat: 22.6000, lng: 85.8300 },
  { city: "East Singhbhum", state: "Jharkhand", lat: 22.8050, lng: 86.2030 },
  { city: "Seraikela", state: "Jharkhand", lat: 22.5790, lng: 85.9920 },
  { city: "Khunti", state: "Jharkhand", lat: 23.0720, lng: 85.2800 },

  // 🟢 TAMIL NADU
  { city: "Coimbatore", state: "Tamil Nadu", lat: 11.0168, lng: 76.9558 },
  { city: "Tiruchirappalli", state: "Tamil Nadu", lat: 10.7905, lng: 78.7047 },
  { city: "Salem", state: "Tamil Nadu", lat: 11.6643, lng: 78.1460 },
  { city: "Erode", state: "Tamil Nadu", lat: 11.3410, lng: 77.7172 },
  { city: "Madurai", state: "Tamil Nadu", lat: 9.9252, lng: 78.1198 },
  { city: "Tirunelveli", state: "Tamil Nadu", lat: 8.7139, lng: 77.7567 },
  { city: "Tiruppur", state: "Tamil Nadu", lat: 11.1085, lng: 77.3411 },
  { city: "Vellore", state: "Tamil Nadu", lat: 12.9165, lng: 79.1325 },
  { city: "Thoothukudi", state: "Tamil Nadu", lat: 8.7642, lng: 78.1348 },
  { city: "Thanjavur", state: "Tamil Nadu", lat: 10.7870, lng: 79.1378 },
  { city: "Dindigul", state: "Tamil Nadu", lat: 10.3624, lng: 77.9695 },
  { city: "Cuddalore", state: "Tamil Nadu", lat: 11.7447, lng: 79.7689 },
  { city: "Kanchipuram", state: "Tamil Nadu", lat: 12.8352, lng: 79.7100 },
  { city: "Nagercoil", state: "Tamil Nadu", lat: 8.1780, lng: 77.4330 },
  { city: "Kumbakonam", state: "Tamil Nadu", lat: 10.9602, lng: 79.3845 },
  { city: "Karur", state: "Tamil Nadu", lat: 10.9601, lng: 78.0766 },
  { city: "Namakkal", state: "Tamil Nadu", lat: 11.2190, lng: 78.1673 },
  { city: "Villupuram", state: "Tamil Nadu", lat: 11.9393, lng: 79.4928 },
  { city: "Pudukkottai", state: "Tamil Nadu", lat: 10.3797, lng: 78.8201 },
  { city: "Sivaganga", state: "Tamil Nadu", lat: 9.8479, lng: 78.4800 },
  { city: "Ramanathapuram", state: "Tamil Nadu", lat: 9.3762, lng: 78.8307 },
  { city: "Virudhunagar", state: "Tamil Nadu", lat: 9.5850, lng: 77.9624 },
  { city: "Krishnagiri", state: "Tamil Nadu", lat: 12.5189, lng: 78.2137 },
  { city: "Dharmapuri", state: "Tamil Nadu", lat: 12.1284, lng: 78.1579 },
  { city: "Tiruvannamalai", state: "Tamil Nadu", lat: 12.2253, lng: 79.0747 },
  { city: "Perambalur", state: "Tamil Nadu", lat: 11.2338, lng: 78.8799 },
  { city: "Ariyalur", state: "Tamil Nadu", lat: 11.1420, lng: 79.0756 },
  { city: "Tiruvallur", state: "Tamil Nadu", lat: 13.1430, lng: 79.9080 },
  { city: "Ranipet", state: "Tamil Nadu", lat: 12.9237, lng: 79.3337 },
  { city: "Tenkasi", state: "Tamil Nadu", lat: 8.9603, lng: 77.3152 },
  { city: "Kallakurichi", state: "Tamil Nadu", lat: 11.7375, lng: 78.9592 },
  { city: "Chengalpattu", state: "Tamil Nadu", lat: 12.6921, lng: 79.9764 },
  { city: "Mayiladuthurai", state: "Tamil Nadu", lat: 11.1030, lng: 79.6520 },

  // 🟢 KERALA
  { city: "Kochi", state: "Kerala", lat: 9.9312, lng: 76.2673 },
  { city: "Thiruvananthapuram", state: "Kerala", lat: 8.5241, lng: 76.9366 },
  { city: "Kozhikode", state: "Kerala", lat: 11.2588, lng: 75.7804 },
  { city: "Thrissur", state: "Kerala", lat: 10.5276, lng: 76.2144 },
  { city: "Kollam", state: "Kerala", lat: 8.8932, lng: 76.6141 },
  { city: "Kannur", state: "Kerala", lat: 11.8745, lng: 75.3704 },
  { city: "Palakkad", state: "Kerala", lat: 10.7867, lng: 76.6548 },
  { city: "Alappuzha", state: "Kerala", lat: 9.4981, lng: 76.3388 },
  { city: "Malappuram", state: "Kerala", lat: 11.0510, lng: 76.0711 },
  { city: "Kottayam", state: "Kerala", lat: 9.5916, lng: 76.5222 },
  { city: "Idukki", state: "Kerala", lat: 9.9189, lng: 77.1025 },
  { city: "Ernakulam", state: "Kerala", lat: 10.0159, lng: 76.3419 },
  { city: "Pathanamthitta", state: "Kerala", lat: 9.2648, lng: 76.7870 },
  { city: "Wayanad", state: "Kerala", lat: 11.6854, lng: 76.1320 },
  { city: "Kasargod", state: "Kerala", lat: 12.4996, lng: 74.9869 },

  // 🟢 KARNATAKA
  { city: "Mysore", state: "Karnataka", lat: 12.2958, lng: 76.6394 },
  { city: "Hubli", state: "Karnataka", lat: 15.3647, lng: 75.1240 },
  { city: "Mangalore", state: "Karnataka", lat: 12.9141, lng: 74.8560 },
  { city: "Belgaum", state: "Karnataka", lat: 15.8497, lng: 74.4977 },
  { city: "Gulbarga", state: "Karnataka", lat: 17.3297, lng: 76.8343 },
  { city: "Davanagere", state: "Karnataka", lat: 14.4644, lng: 75.9218 },
  { city: "Bellary", state: "Karnataka", lat: 15.1394, lng: 76.9214 },
  { city: "Bijapur", state: "Karnataka", lat: 16.8302, lng: 75.7100 },
  { city: "Shimoga", state: "Karnataka", lat: 13.9299, lng: 75.5681 },
  { city: "Tumkur", state: "Karnataka", lat: 13.3392, lng: 77.1010 },
  { city: "Raichur", state: "Karnataka", lat: 16.2120, lng: 77.3566 },
  { city: "Bidar", state: "Karnataka", lat: 17.9104, lng: 77.5199 },
  { city: "Hassan", state: "Karnataka", lat: 13.0068, lng: 76.0996 },
  { city: "Mandya", state: "Karnataka", lat: 12.5218, lng: 76.8951 },
  { city: "Chikmagalur", state: "Karnataka", lat: 13.3161, lng: 75.7720 },
  { city: "Kodagu", state: "Karnataka", lat: 12.3375, lng: 75.8069 },
  { city: "Udupi", state: "Karnataka", lat: 13.3409, lng: 74.7421 },
  { city: "Dharwad", state: "Karnataka", lat: 15.4589, lng: 75.0078 },
  { city: "Gadag", state: "Karnataka", lat: 15.4166, lng: 75.6275 },
  { city: "Haveri", state: "Karnataka", lat: 14.7939, lng: 75.3996 },
  { city: "Chitradurga", state: "Karnataka", lat: 14.2260, lng: 76.3975 },
  { city: "Chamarajanagar", state: "Karnataka", lat: 11.9249, lng: 76.9435 },
  { city: "Kolar", state: "Karnataka", lat: 13.1360, lng: 78.1290 },
  { city: "Chikkaballapur", state: "Karnataka", lat: 13.4344, lng: 77.7269 },
  { city: "Ramanagara", state: "Karnataka", lat: 12.7157, lng: 77.2797 },
  { city: "Bagalkot", state: "Karnataka", lat: 16.1826, lng: 75.6960 },
  { city: "Koppal", state: "Karnataka", lat: 15.3508, lng: 76.1549 },
  { city: "Yadgir", state: "Karnataka", lat: 16.7660, lng: 77.1350 },
  { city: "Vijayapura", state: "Karnataka", lat: 16.8302, lng: 75.7100 },
  { city: "Ballari", state: "Karnataka", lat: 15.1394, lng: 76.9214 },

  // 🟢 ANDHRA PRADESH & TELANGANA
  { city: "Visakhapatnam", state: "Andhra Pradesh", lat: 17.6868, lng: 83.2185 },
  { city: "Vijayawada", state: "Andhra Pradesh", lat: 16.5062, lng: 80.6480 },
  { city: "Guntur", state: "Andhra Pradesh", lat: 16.3067, lng: 80.4365 },
  { city: "Nellore", state: "Andhra Pradesh", lat: 14.4426, lng: 79.9865 },
  { city: "Kurnool", state: "Andhra Pradesh", lat: 15.8281, lng: 78.0373 },
  { city: "Rajahmundry", state: "Andhra Pradesh", lat: 17.0005, lng: 81.8040 },
  { city: "Tirupati", state: "Andhra Pradesh", lat: 13.6288, lng: 79.4192 },
  { city: "Kakinada", state: "Andhra Pradesh", lat: 16.9891, lng: 82.2475 },
  { city: "Anantapur", state: "Andhra Pradesh", lat: 14.6819, lng: 77.6006 },
  { city: "Kadapa", state: "Andhra Pradesh", lat: 14.4673, lng: 78.8242 },
  { city: "Vizianagaram", state: "Andhra Pradesh", lat: 18.1067, lng: 83.3956 },
  { city: "Srikakulam", state: "Andhra Pradesh", lat: 18.2949, lng: 83.8938 },
  { city: "Eluru", state: "Andhra Pradesh", lat: 16.7107, lng: 81.0952 },
  { city: "Ongole", state: "Andhra Pradesh", lat: 15.5057, lng: 80.0499 },
  { city: "Chittoor", state: "Andhra Pradesh", lat: 13.2167, lng: 79.1003 },
  { city: "Machilipatnam", state: "Andhra Pradesh", lat: 16.1875, lng: 81.1389 },
  { city: "Bhimavaram", state: "Andhra Pradesh", lat: 16.5449, lng: 81.5212 },
  { city: "Narasaraopet", state: "Andhra Pradesh", lat: 16.2348, lng: 80.0498 },
  { city: "Tenali", state: "Andhra Pradesh", lat: 16.2430, lng: 80.6392 },
  { city: "Proddatur", state: "Andhra Pradesh", lat: 14.7502, lng: 78.5481 },
  { city: "Hindupur", state: "Andhra Pradesh", lat: 13.8290, lng: 77.4914 },
  { city: "Adoni", state: "Andhra Pradesh", lat: 15.6280, lng: 77.2740 },
  { city: "Warangal", state: "Telangana", lat: 17.9689, lng: 79.5941 },
  { city: "Nizamabad", state: "Telangana", lat: 18.6705, lng: 78.0975 },
  { city: "Karimnagar", state: "Telangana", lat: 18.4386, lng: 79.1288 },
  { city: "Khammam", state: "Telangana", lat: 17.2473, lng: 80.1514 },
  { city: "Mahbubnagar", state: "Telangana", lat: 16.7376, lng: 77.9875 },
  { city: "Nalgonda", state: "Telangana", lat: 17.0575, lng: 79.2671 },
  { city: "Adilabad", state: "Telangana", lat: 19.6640, lng: 78.5320 },
  { city: "Suryapet", state: "Telangana", lat: 17.1420, lng: 79.6240 },
  { city: "Siddipet", state: "Telangana", lat: 18.1010, lng: 78.8520 },
  { city: "Ramagundam", state: "Telangana", lat: 18.7570, lng: 79.4749 },
  { city: "Mancherial", state: "Telangana", lat: 18.8698, lng: 79.4618 },
  { city: "Jagtial", state: "Telangana", lat: 18.7938, lng: 78.9141 },
  { city: "Peddapalli", state: "Telangana", lat: 18.6152, lng: 79.3751 },
  { city: "Kamareddy", state: "Telangana", lat: 18.3190, lng: 78.3400 },
  { city: "Sangareddy", state: "Telangana", lat: 17.6214, lng: 78.0850 },
  { city: "Medak", state: "Telangana", lat: 18.0490, lng: 78.2750 },
  { city: "Vikarabad", state: "Telangana", lat: 17.3338, lng: 77.9030 },
  { city: "Wanaparthy", state: "Telangana", lat: 16.3608, lng: 78.0631 },
  { city: "Nagarkurnool", state: "Telangana", lat: 16.4813, lng: 78.3268 },
  { city: "Narayanpet", state: "Telangana", lat: 16.7451, lng: 77.4974 },
  { city: "Gadwal", state: "Telangana", lat: 16.2328, lng: 77.7945 },
  { city: "Yadadri Bhuvanagiri", state: "Telangana", lat: 17.5885, lng: 79.0044 },
  { city: "Bhadradri Kothagudem", state: "Telangana", lat: 17.5490, lng: 80.6190 },
  { city: "Mulugu", state: "Telangana", lat: 18.1960, lng: 80.0570 },
  { city: "Jayashankar Bhupalpally", state: "Telangana", lat: 18.4350, lng: 79.9100 },
  { city: "Rajanna Sircilla", state: "Telangana", lat: 18.3866, lng: 78.8280 },
  { city: "Parvathipuram Manyam", state: "Andhra Pradesh", lat: 18.7830, lng: 83.4260 },

  // 🟢 PUNJAB, HARYANA & NORTH
  { city: "Chandigarh", state: "Chandigarh", lat: 30.7333, lng: 76.7794 },
  { city: "Gurugram", state: "Haryana", lat: 28.4595, lng: 77.0266 },
  { city: "Faridabad", state: "Haryana", lat: 28.4089, lng: 77.3178 },
  { city: "Panipat", state: "Haryana", lat: 29.3909, lng: 76.9635 },
  { city: "Ambala", state: "Haryana", lat: 30.3782, lng: 76.7767 },
  { city: "Rohtak", state: "Haryana", lat: 28.8955, lng: 76.5892 },
  { city: "Sonipat", state: "Haryana", lat: 28.9288, lng: 77.0200 },
  { city: "Karnal", state: "Haryana", lat: 29.6857, lng: 76.9905 },
  { city: "Hisar", state: "Haryana", lat: 29.1492, lng: 75.7217 },
  { city: "Sirsa", state: "Haryana", lat: 29.5332, lng: 75.0260 },
  { city: "Bhiwani", state: "Haryana", lat: 28.7930, lng: 76.1390 },
  { city: "Fatehabad", state: "Haryana", lat: 29.5200, lng: 75.4520 },
  { city: "Jind", state: "Haryana", lat: 29.3164, lng: 76.3163 },
  { city: "Kaithal", state: "Haryana", lat: 29.8012, lng: 76.3986 },
  { city: "Kurukshetra", state: "Haryana", lat: 29.9695, lng: 76.8783 },
  { city: "Yamunanagar", state: "Haryana", lat: 30.1290, lng: 77.2674 },
  { city: "Panchkula", state: "Haryana", lat: 30.6942, lng: 76.8606 },
  { city: "Rewari", state: "Haryana", lat: 28.1989, lng: 76.6180 },
  { city: "Mahendragarh", state: "Haryana", lat: 28.2780, lng: 76.1480 },
  { city: "Nuh", state: "Haryana", lat: 28.1040, lng: 77.0000 },
  { city: "Palwal", state: "Haryana", lat: 28.1440, lng: 77.3280 },
  { city: "Amritsar", state: "Punjab", lat: 31.6340, lng: 74.8723 },
  { city: "Ludhiana", state: "Punjab", lat: 30.9010, lng: 75.8573 },
  { city: "Jalandhar", state: "Punjab", lat: 31.3260, lng: 75.5762 },
  { city: "Patiala", state: "Punjab", lat: 30.3398, lng: 76.3869 },
  { city: "Bathinda", state: "Punjab", lat: 30.2110, lng: 74.9455 },
  { city: "Mohali", state: "Punjab", lat: 30.7046, lng: 76.7179 },
  { city: "Hoshiarpur", state: "Punjab", lat: 31.5143, lng: 75.9113 },
  { city: "Gurdaspur", state: "Punjab", lat: 32.0398, lng: 75.4021 },
  { city: "Pathankot", state: "Punjab", lat: 32.2746, lng: 75.6523 },
  { city: "Firozpur", state: "Punjab", lat: 30.9252, lng: 74.6101 },
  { city: "Moga", state: "Punjab", lat: 30.8168, lng: 75.1703 },
  { city: "Barnala", state: "Punjab", lat: 30.3782, lng: 75.5483 },
  { city: "Faridkot", state: "Punjab", lat: 30.6745, lng: 74.7570 },
  { city: "Muktsar", state: "Punjab", lat: 30.4743, lng: 74.5140 },
  { city: "Fazilka", state: "Punjab", lat: 30.4010, lng: 74.0250 },
  { city: "Ferozepur", state: "Punjab", lat: 30.9170, lng: 74.6100 },
  { city: "Rupnagar", state: "Punjab", lat: 30.9647, lng: 76.5212 },
  { city: "Nawanshahr", state: "Punjab", lat: 31.1250, lng: 76.1150 },
  { city: "Kapurthala", state: "Punjab", lat: 31.3811, lng: 75.3803 },
  { city: "Tarn Taran", state: "Punjab", lat: 31.4523, lng: 74.9276 },
  { city: "Sangrur", state: "Punjab", lat: 30.2445, lng: 75.8439 },
  { city: "Malerkotla", state: "Punjab", lat: 30.5296, lng: 75.8853 },
  { city: "Shimla", state: "Himachal Pradesh", lat: 31.1048, lng: 77.1734 },
  { city: "Dehradun", state: "Uttarakhand", lat: 30.3165, lng: 78.0322 },
  { city: "Haldwani", state: "Uttarakhand", lat: 29.2183, lng: 79.5120 },
  { city: "Haridwar", state: "Uttarakhand", lat: 29.9457, lng: 78.1642 },
  { city: "Roorkee", state: "Uttarakhand", lat: 29.8543, lng: 77.8880 },
  { city: "Dharamsala", state: "Himachal Pradesh", lat: 32.2190, lng: 76.3234 },
  { city: "Mandi", state: "Himachal Pradesh", lat: 31.7084, lng: 76.9322 },
  { city: "Solan", state: "Himachal Pradesh", lat: 30.9045, lng: 77.0967 },
  { city: "Kullu", state: "Himachal Pradesh", lat: 31.9579, lng: 77.1095 },
  { city: "Kangra", state: "Himachal Pradesh", lat: 32.0990, lng: 76.2670 },
  { city: "Bilaspur", state: "Himachal Pradesh", lat: 31.3370, lng: 76.7570 },
  { city: "Hamirpur", state: "Himachal Pradesh", lat: 31.6847, lng: 76.5216 },
  { city: "Una", state: "Himachal Pradesh", lat: 31.4685, lng: 76.2706 },
  { city: "Sirmaur", state: "Himachal Pradesh", lat: 30.5580, lng: 77.4540 },
  { city: "Kinnaur", state: "Himachal Pradesh", lat: 31.5910, lng: 78.4360 },
  { city: "Lahaul Spiti", state: "Himachal Pradesh", lat: 32.5050, lng: 77.3790 },
  { city: "Nahan", state: "Himachal Pradesh", lat: 30.5574, lng: 77.2952 },
  { city: "Rishikesh", state: "Uttarakhand", lat: 30.0869, lng: 78.2676 },
  { city: "Rudrapur", state: "Uttarakhand", lat: 28.9786, lng: 79.4014 },
  { city: "Kashipur", state: "Uttarakhand", lat: 29.2108, lng: 78.9601 },
  { city: "Ramnagar", state: "Uttarakhand", lat: 29.3942, lng: 79.1277 },
  { city: "Pithoragarh", state: "Uttarakhand", lat: 29.5830, lng: 80.2180 },
  { city: "Almora", state: "Uttarakhand", lat: 29.5971, lng: 79.6591 },
  { city: "Nainital", state: "Uttarakhand", lat: 29.3803, lng: 79.4636 },
  { city: "Udham Singh Nagar", state: "Uttarakhand", lat: 28.9934, lng: 79.5117 },
  { city: "Tehri", state: "Uttarakhand", lat: 30.3898, lng: 78.4803 },
  { city: "Uttarkashi", state: "Uttarakhand", lat: 30.7280, lng: 78.4510 },
  { city: "Chamoli", state: "Uttarakhand", lat: 30.4003, lng: 79.3233 },
  { city: "Rudraprayag", state: "Uttarakhand", lat: 30.2847, lng: 78.9814 },
  { city: "Bageshwar", state: "Uttarakhand", lat: 29.8340, lng: 79.7700 },
  { city: "Champawat", state: "Uttarakhand", lat: 29.3342, lng: 80.0885 },
  { city: "Pauri", state: "Uttarakhand", lat: 30.1464, lng: 78.7781 },

  // 🟢 CHHATTISGARH
  { city: "Raipur", state: "Chhattisgarh", lat: 21.2514, lng: 81.6296 },
  { city: "Durg", state: "Chhattisgarh", lat: 21.1904, lng: 81.2849 },
  { city: "Bhilai", state: "Chhattisgarh", lat: 21.1938, lng: 81.3509 },
  { city: "Bilaspur", state: "Chhattisgarh", lat: 22.0797, lng: 82.1409 },
  { city: "Korba", state: "Chhattisgarh", lat: 22.3595, lng: 82.6800 },
  { city: "Raigarh", state: "Chhattisgarh", lat: 21.8980, lng: 83.3950 },
  { city: "Jagdalpur", state: "Chhattisgarh", lat: 19.0785, lng: 82.0230 },
  { city: "Ambikapur", state: "Chhattisgarh", lat: 23.1174, lng: 83.1962 },
  { city: "Rajnandgaon", state: "Chhattisgarh", lat: 21.0972, lng: 81.0312 },
  { city: "Mahasamund", state: "Chhattisgarh", lat: 21.1090, lng: 82.0920 },
  { city: "Dhamtari", state: "Chhattisgarh", lat: 20.7080, lng: 81.5490 },
  { city: "Kanker", state: "Chhattisgarh", lat: 20.2710, lng: 81.4880 },
  { city: "Kondagaon", state: "Chhattisgarh", lat: 19.5960, lng: 81.6640 },
  { city: "Narayanpur", state: "Chhattisgarh", lat: 19.6970, lng: 81.2430 },
  { city: "Bijapur", state: "Chhattisgarh", lat: 18.8220, lng: 80.8050 },
  { city: "Sukma", state: "Chhattisgarh", lat: 18.3860, lng: 81.6600 },
  { city: "Dantewada", state: "Chhattisgarh", lat: 18.8910, lng: 81.3490 },
  { city: "Bastar", state: "Chhattisgarh", lat: 19.1233, lng: 81.9570 },
  { city: "Kabirdham", state: "Chhattisgarh", lat: 22.0390, lng: 81.2690 },
  { city: "Bemetara", state: "Chhattisgarh", lat: 21.7110, lng: 81.5330 },
  { city: "Baloda Bazar", state: "Chhattisgarh", lat: 21.6560, lng: 82.1570 },
  { city: "Gariaband", state: "Chhattisgarh", lat: 20.6310, lng: 82.0500 },
  { city: "Balod", state: "Chhattisgarh", lat: 20.7300, lng: 81.2050 },
  { city: "Mungeli", state: "Chhattisgarh", lat: 22.0640, lng: 81.6850 },
  { city: "Janjgir Champa", state: "Chhattisgarh", lat: 21.9970, lng: 82.5710 },
  { city: "Koriya", state: "Chhattisgarh", lat: 23.2800, lng: 82.7200 },
  { city: "Surajpur", state: "Chhattisgarh", lat: 23.2180, lng: 82.8720 },
  { city: "Balrampur", state: "Chhattisgarh", lat: 23.3980, lng: 83.5850 },
  { city: "Surguja", state: "Chhattisgarh", lat: 23.1320, lng: 83.0680 },
  { city: "Gaurela Pendra Marwahi", state: "Chhattisgarh", lat: 22.7570, lng: 81.7590 },
  { city: "Sarangarh Bilaigarh", state: "Chhattisgarh", lat: 21.5870, lng: 83.0730 },
  { city: "Khairagarh", state: "Chhattisgarh", lat: 21.4170, lng: 80.9740 },
  { city: "Manendragarh", state: "Chhattisgarh", lat: 23.1990, lng: 82.2290 },

  // 🟢 WEST BENGAL & ODISHA
  { city: "Asansol", state: "West Bengal", lat: 23.6739, lng: 86.9524 },
  { city: "Durgapur", state: "West Bengal", lat: 23.5204, lng: 87.3119 },
  { city: "Siliguri", state: "West Bengal", lat: 26.7271, lng: 88.3953 },
  { city: "Howrah", state: "West Bengal", lat: 22.5958, lng: 88.3259 },
  { city: "Kharagpur", state: "West Bengal", lat: 22.3302, lng: 87.3237 },
  { city: "Malda", state: "West Bengal", lat: 25.0111, lng: 88.1411 },
  { city: "Bardhaman", state: "West Bengal", lat: 23.2324, lng: 87.8615 },
  { city: "Murshidabad", state: "West Bengal", lat: 24.1832, lng: 88.2710 },
  { city: "Nadia", state: "West Bengal", lat: 23.4698, lng: 88.5559 },
  { city: "North 24 Parganas", state: "West Bengal", lat: 22.8500, lng: 88.6300 },
  { city: "South 24 Parganas", state: "West Bengal", lat: 22.0200, lng: 88.5000 },
  { city: "Hooghly", state: "West Bengal", lat: 22.9100, lng: 88.3700 },
  { city: "Birbhum", state: "West Bengal", lat: 23.8900, lng: 87.5300 },
  { city: "Bankura", state: "West Bengal", lat: 23.2300, lng: 87.0700 },
  { city: "Purulia", state: "West Bengal", lat: 23.3300, lng: 86.3600 },
  { city: "Jalpaiguri", state: "West Bengal", lat: 26.5450, lng: 88.7180 },
  { city: "Cooch Behar", state: "West Bengal", lat: 26.3244, lng: 89.4461 },
  { city: "Darjeeling", state: "West Bengal", lat: 27.0360, lng: 88.2627 },
  { city: "Kalimpong", state: "West Bengal", lat: 27.0660, lng: 88.4690 },
  { city: "Alipurduar", state: "West Bengal", lat: 26.4870, lng: 89.5270 },
  { city: "Jhargram", state: "West Bengal", lat: 22.4505, lng: 86.9960 },
  { city: "Paschim Medinipur", state: "West Bengal", lat: 22.4230, lng: 87.3190 },
  { city: "Purba Medinipur", state: "West Bengal", lat: 22.2500, lng: 87.9300 },
  { city: "Bhubaneswar", state: "Odisha", lat: 20.2961, lng: 85.8245 },
  { city: "Cuttack", state: "Odisha", lat: 20.4625, lng: 85.8830 },
  { city: "Rourkela", state: "Odisha", lat: 22.2604, lng: 84.8536 },
  { city: "Brahmapur", state: "Odisha", lat: 19.3150, lng: 84.7941 },
  { city: "Puri", state: "Odisha", lat: 19.8133, lng: 85.8314 },
  { city: "Sambalpur", state: "Odisha", lat: 21.4669, lng: 83.9812 },
  { city: "Balasore", state: "Odisha", lat: 21.4942, lng: 86.9308 },
  { city: "Bhadrak", state: "Odisha", lat: 21.0548, lng: 86.4988 },
  { city: "Keonjhar", state: "Odisha", lat: 21.6288, lng: 85.5814 },
  { city: "Angul", state: "Odisha", lat: 20.8430, lng: 85.1010 },
  { city: "Dhenkanal", state: "Odisha", lat: 20.6630, lng: 85.5970 },
  { city: "Kendrapara", state: "Odisha", lat: 20.5020, lng: 86.4210 },
  { city: "Jagatsinghpur", state: "Odisha", lat: 20.2570, lng: 86.1700 },
  { city: "Jajpur", state: "Odisha", lat: 20.8490, lng: 86.3340 },
  { city: "Khordha", state: "Odisha", lat: 20.1800, lng: 85.6200 },
  { city: "Nayagarh", state: "Odisha", lat: 20.1280, lng: 85.0960 },
  { city: "Ganjam", state: "Odisha", lat: 19.3860, lng: 84.6940 },
  { city: "Gajapati", state: "Odisha", lat: 18.9900, lng: 84.1090 },
  { city: "Rayagada", state: "Odisha", lat: 19.1671, lng: 83.4166 },
  { city: "Koraput", state: "Odisha", lat: 18.8130, lng: 82.7100 },
  { city: "Nabarangpur", state: "Odisha", lat: 19.2240, lng: 82.5560 },
  { city: "Malkangiri", state: "Odisha", lat: 18.3510, lng: 81.8870 },
  { city: "Kandhamal", state: "Odisha", lat: 20.4690, lng: 84.2300 },
  { city: "Boudh", state: "Odisha", lat: 20.8400, lng: 84.3240 },
  { city: "Sonepur", state: "Odisha", lat: 20.8290, lng: 83.9160 },
  { city: "Bargarh", state: "Odisha", lat: 21.3340, lng: 83.6190 },
  { city: "Bolangir", state: "Odisha", lat: 20.6720, lng: 83.4880 },
  { city: "Nuapada", state: "Odisha", lat: 20.8100, lng: 82.5360 },
  { city: "Kalahandi", state: "Odisha", lat: 19.9120, lng: 83.1720 },
  { city: "Jharsuguda", state: "Odisha", lat: 21.8560, lng: 84.0060 },
  { city: "Deogarh", state: "Odisha", lat: 21.5260, lng: 84.7370 },
  { city: "Sundargarh", state: "Odisha", lat: 22.1170, lng: 84.0300 },
  { city: "Mayurbhanj", state: "Odisha", lat: 21.9240, lng: 86.7320 },
  { city: "Kendujhar", state: "Odisha", lat: 21.6290, lng: 85.5810 },

  // 🟢 NORTH EAST
  { city: "Guwahati", state: "Assam", lat: 26.1445, lng: 91.7362 },
  { city: "Shillong", state: "Meghalaya", lat: 25.5788, lng: 91.8933 },
  { city: "Imphal", state: "Manipur", lat: 24.8170, lng: 93.9368 },
  { city: "Aizawl", state: "Mizoram", lat: 23.7271, lng: 92.7176 },
  { city: "Kohima", state: "Nagaland", lat: 25.6751, lng: 94.1086 },
  { city: "Dimapur", state: "Nagaland", lat: 25.9060, lng: 93.7255 },
  { city: "Itanagar", state: "Arunachal Pradesh", lat: 27.0844, lng: 93.6053 },
  { city: "Gangtok", state: "Sikkim", lat: 27.3389, lng: 88.6065 },
  { city: "Agartala", state: "Tripura", lat: 23.8315, lng: 91.2868 },
  { city: "Silchar", state: "Assam", lat: 24.8333, lng: 92.7789 },
  { city: "Dibrugarh", state: "Assam", lat: 27.4728, lng: 94.9120 },
  { city: "Nagaon", state: "Assam", lat: 26.3480, lng: 92.6840 },
  { city: "Jorhat", state: "Assam", lat: 26.7509, lng: 94.2037 },
  { city: "Tinsukia", state: "Assam", lat: 27.4892, lng: 95.3600 },
  { city: "Tezpur", state: "Assam", lat: 26.6333, lng: 92.8000 },
  { city: "Karimganj", state: "Assam", lat: 24.8654, lng: 92.3590 },
  { city: "Bongaigaon", state: "Assam", lat: 26.4766, lng: 90.5582 },
  { city: "Dhubri", state: "Assam", lat: 26.0200, lng: 89.9800 },
  { city: "Goalpara", state: "Assam", lat: 26.1700, lng: 90.6200 },
  { city: "Kamrup", state: "Assam", lat: 26.1200, lng: 91.4800 },
  { city: "Nalbari", state: "Assam", lat: 26.4464, lng: 91.4380 },
  { city: "Barpeta", state: "Assam", lat: 26.3219, lng: 91.0019 },
  { city: "Darrang", state: "Assam", lat: 26.4500, lng: 92.0000 },
  { city: "Sonitpur", state: "Assam", lat: 26.6300, lng: 92.8000 },
  { city: "Lakhimpur", state: "Assam", lat: 27.2348, lng: 94.1015 },
  { city: "Dhemaji", state: "Assam", lat: 27.4800, lng: 94.5700 },
  { city: "Sibsagar", state: "Assam", lat: 26.9849, lng: 94.6365 },
  { city: "Golaghat", state: "Assam", lat: 26.5150, lng: 93.9720 },
  { city: "Karbi Anglong", state: "Assam", lat: 25.9700, lng: 93.4500 },
  { city: "Diphu", state: "Assam", lat: 25.8400, lng: 93.4200 },
  { city: "Haflong", state: "Assam", lat: 25.1643, lng: 93.0218 },
  { city: "Tura", state: "Meghalaya", lat: 25.5149, lng: 90.2133 },
  { city: "Jowai", state: "Meghalaya", lat: 25.4500, lng: 92.2000 },
  { city: "Nongpoh", state: "Meghalaya", lat: 25.9000, lng: 91.8800 },
  { city: "Lunglei", state: "Mizoram", lat: 22.8884, lng: 92.7355 },
  { city: "Champhai", state: "Mizoram", lat: 23.4580, lng: 93.3300 },
  { city: "Kolasib", state: "Mizoram", lat: 24.2270, lng: 92.6820 },
  { city: "Serchhip", state: "Mizoram", lat: 23.3040, lng: 92.8440 },
  { city: "Lawngtlai", state: "Mizoram", lat: 22.0230, lng: 92.9020 },
  { city: "Saiha", state: "Mizoram", lat: 22.4890, lng: 92.9740 },
  { city: "Mamit", state: "Mizoram", lat: 23.9330, lng: 92.4820 },
  { city: "Hnahthial", state: "Mizoram", lat: 22.7360, lng: 92.8940 },
  { city: "Khawzawl", state: "Mizoram", lat: 23.6870, lng: 93.2080 },
  { city: "Saitual", state: "Mizoram", lat: 23.7840, lng: 92.9870 },
  { city: "Wokha", state: "Nagaland", lat: 26.1006, lng: 94.2599 },
  { city: "Mokokchung", state: "Nagaland", lat: 26.3244, lng: 94.5137 },
  { city: "Tuensang", state: "Nagaland", lat: 26.2724, lng: 94.8178 },
  { city: "Mon", state: "Nagaland", lat: 26.7230, lng: 95.0290 },
  { city: "Phek", state: "Nagaland", lat: 25.6740, lng: 94.4690 },
  { city: "Zunheboto", state: "Nagaland", lat: 25.9180, lng: 94.5220 },
  { city: "Longleng", state: "Nagaland", lat: 26.5230, lng: 94.5940 },
  { city: "Kiphire", state: "Nagaland", lat: 25.9740, lng: 94.9910 },
  { city: "Peren", state: "Nagaland", lat: 25.5660, lng: 93.7260 },
  { city: "Thoubal", state: "Manipur", lat: 24.6380, lng: 94.0100 },
  { city: "Bishnupur", state: "Manipur", lat: 24.6280, lng: 93.7760 },
  { city: "Churachandpur", state: "Manipur", lat: 24.3337, lng: 93.6744 },
  { city: "Senapati", state: "Manipur", lat: 25.2665, lng: 94.0153 },
  { city: "Ukhrul", state: "Manipur", lat: 25.0983, lng: 94.3594 },
  { city: "Chandel", state: "Manipur", lat: 24.3280, lng: 94.0340 },
  { city: "Tamenglong", state: "Manipur", lat: 24.9800, lng: 93.5010 },
  { city: "Jiribam", state: "Manipur", lat: 24.8010, lng: 93.1210 },
  { city: "Naharlagun", state: "Arunachal Pradesh", lat: 27.1043, lng: 93.6960 },
  { city: "Pasighat", state: "Arunachal Pradesh", lat: 28.0660, lng: 95.3270 },
  { city: "Ziro", state: "Arunachal Pradesh", lat: 27.5400, lng: 93.8270 },
  { city: "Bomdila", state: "Arunachal Pradesh", lat: 27.2680, lng: 92.4150 },
  { city: "Tezu", state: "Arunachal Pradesh", lat: 27.9220, lng: 96.1700 },
  { city: "Dharmanagar", state: "Tripura", lat: 24.3780, lng: 92.1620 },
  { city: "Udaipur", state: "Tripura", lat: 23.5320, lng: 91.4870 },
  { city: "Kailashahar", state: "Tripura", lat: 24.3320, lng: 92.0110 },
  { city: "Belonia", state: "Tripura", lat: 23.2510, lng: 91.4540 },
  { city: "Gyalshing", state: "Sikkim", lat: 27.2820, lng: 88.2580 },
  { city: "Namchi", state: "Sikkim", lat: 27.1660, lng: 88.3620 },
  { city: "Mangan", state: "Sikkim", lat: 27.5130, lng: 88.5230 },

  // 🟢 J&K & LADAKH
  { city: "Srinagar", state: "Jammu and Kashmir", lat: 34.0837, lng: 74.7973 },
  { city: "Jammu", state: "Jammu and Kashmir", lat: 32.7266, lng: 74.8570 },
  { city: "Anantnag", state: "Jammu and Kashmir", lat: 33.7311, lng: 75.1487 },
  { city: "Baramulla", state: "Jammu and Kashmir", lat: 34.2010, lng: 74.3430 },
  { city: "Sopore", state: "Jammu and Kashmir", lat: 34.2990, lng: 74.4720 },
  { city: "Kathua", state: "Jammu and Kashmir", lat: 32.3830, lng: 75.5150 },
  { city: "Udhampur", state: "Jammu and Kashmir", lat: 32.9160, lng: 75.1420 },
  { city: "Rajouri", state: "Jammu and Kashmir", lat: 33.3770, lng: 74.3090 },
  { city: "Punch", state: "Jammu and Kashmir", lat: 33.7720, lng: 74.0900 },
  { city: "Doda", state: "Jammu and Kashmir", lat: 33.1450, lng: 75.5490 },
  { city: "Kishtwar", state: "Jammu and Kashmir", lat: 33.3130, lng: 75.7660 },
  { city: "Ramban", state: "Jammu and Kashmir", lat: 33.2440, lng: 75.2410 },
  { city: "Reasi", state: "Jammu and Kashmir", lat: 33.0820, lng: 74.8300 },
  { city: "Samba", state: "Jammu and Kashmir", lat: 32.5680, lng: 75.1190 },
  { city: "Leh", state: "Ladakh", lat: 34.1526, lng: 77.5771 },
  { city: "Kargil", state: "Ladakh", lat: 34.5540, lng: 76.1260 },

  // 🟢 DELHI NCR
   { city: "New Delhi", state: "Delhi", lat: 28.6139, lng: 77.2090 },
  { city: "Central Delhi", state: "Delhi", lat: 28.6562, lng: 77.2410 },
  { city: "North Delhi", state: "Delhi", lat: 28.7041, lng: 77.1025 },
  { city: "South Delhi", state: "Delhi", lat: 28.5355, lng: 77.2420 },
  { city: "East Delhi", state: "Delhi", lat: 28.6392, lng: 77.2900 },
  { city: "West Delhi", state: "Delhi", lat: 28.6664, lng: 77.0720 },

  // West Delhi
  { city: "Dwarka", state: "Delhi", lat: 28.5921, lng: 77.0460 },
  { city: "Janakpuri", state: "Delhi", lat: 28.6270, lng: 77.0820 },
  { city: "Tilak Nagar", state: "Delhi", lat: 28.6398, lng: 77.0910 },
  { city: "Rajouri Garden", state: "Delhi", lat: 28.6495, lng: 77.1221 },
  { city: "Punjabi Bagh", state: "Delhi", lat: 28.6686, lng: 77.1250 },
  { city: "Paschim Vihar", state: "Delhi", lat: 28.6692, lng: 77.1025 },

  // North West Delhi
  { city: "Pitampura", state: "Delhi", lat: 28.7033, lng: 77.1322 },
  { city: "Rohini", state: "Delhi", lat: 28.7257, lng: 77.1183 },
  { city: "Shalimar Bagh", state: "Delhi", lat: 28.7161, lng: 77.1645 },
  { city: "Ashok Vihar", state: "Delhi", lat: 28.6922, lng: 77.1734 },
  { city: "Shakurpur", state: "Delhi", lat: 28.6895, lng: 77.1415 },
  { city: "Tri Nagar", state: "Delhi", lat: 28.6778, lng: 77.1628 },

  // North Delhi
  { city: "Model Town", state: "Delhi", lat: 28.7045, lng: 77.1932 },
  { city: "Civil Lines", state: "Delhi", lat: 28.6765, lng: 77.2250 },
  { city: "Kamla Nagar", state: "Delhi", lat: 28.6807, lng: 77.2056 },
  { city: "Burari", state: "Delhi", lat: 28.7530, lng: 77.1978 },

  // South Delhi
  { city: "Saket", state: "Delhi", lat: 28.5245, lng: 77.2066 },
  { city: "Malviya Nagar", state: "Delhi", lat: 28.5360, lng: 77.2117 },
  { city: "Hauz Khas", state: "Delhi", lat: 28.5494, lng: 77.2001 },
  { city: "Greater Kailash", state: "Delhi", lat: 28.5494, lng: 77.2428 },
  { city: "Vasant Kunj", state: "Delhi", lat: 28.5246, lng: 77.1544 },
  { city: "Kalkaji", state: "Delhi", lat: 28.5497, lng: 77.2588 },
  { city: "Lajpat Nagar", state: "Delhi", lat: 28.5677, lng: 77.2431 },
  { city: "Defence Colony", state: "Delhi", lat: 28.5725, lng: 77.2326 },
  { city: "Nehru Place", state: "Delhi", lat: 28.5490, lng: 77.2510 },

  // East Delhi
  { city: "Shahdara", state: "Delhi", lat: 28.6746, lng: 77.2956 },
  { city: "Preet Vihar", state: "Delhi", lat: 28.6402, lng: 77.2929 },
  { city: "Laxmi Nagar", state: "Delhi", lat: 28.6304, lng: 77.2773 },
  { city: "Mayur Vihar", state: "Delhi", lat: 28.6040, lng: 77.2963 },
  { city: "Patparganj", state: "Delhi", lat: 28.6275, lng: 77.3032 },

  // Central Delhi
  { city: "Karol Bagh", state: "Delhi", lat: 28.6519, lng: 77.1909 },
  { city: "Connaught Place", state: "Delhi", lat: 28.6315, lng: 77.2167 },
  { city: "Paharganj", state: "Delhi", lat: 28.6430, lng: 77.2167 },
  { city: "Daryaganj", state: "Delhi", lat: 28.6446, lng: 77.2436 },
  { city: "Chanakyapuri", state: "Delhi", lat: 28.5933, lng: 77.1883 },

  // South West Delhi
  { city: "Najafgarh", state: "Delhi", lat: 28.6128, lng: 76.9856 },
  { city: "Palam", state: "Delhi", lat: 28.5919, lng: 77.0893 },
  { city: "Mahipalpur", state: "Delhi", lat: 28.5467, lng: 77.1221 },
  { city: "Delhi Cantonment", state: "Delhi", lat: 28.5969, lng: 77.1370 },

  // North East Delhi
  { city: "Seelampur", state: "Delhi", lat: 28.6698, lng: 77.2691 },
  { city: "Yamuna Vihar", state: "Delhi", lat: 28.7007, lng: 77.2722 },
  { city: "Bhajanpura", state: "Delhi", lat: 28.7036, lng: 77.2698 },

  // 🟢 GOA
  { city: "Panaji", state: "Goa", lat: 15.4909, lng: 73.8278 },
  { city: "Margao", state: "Goa", lat: 15.2993, lng: 73.9862 },
  { city: "Vasco da Gama", state: "Goa", lat: 15.3980, lng: 73.8150 },
  { city: "Mapusa", state: "Goa", lat: 15.5930, lng: 73.8090 },
  { city: "Ponda", state: "Goa", lat: 15.4020, lng: 74.0010 },
  { city: "North Goa", state: "Goa", lat: 15.5490, lng: 73.8570 },
  { city: "South Goa", state: "Goa", lat: 15.1730, lng: 74.0110 },

  // 🟢 UNION TERRITORIES
  { city: "Puducherry", state: "Puducherry", lat: 11.9416, lng: 79.8083 },
  { city: "Karaikal", state: "Puducherry", lat: 10.9254, lng: 79.8380 },
  { city: "Mahe", state: "Puducherry", lat: 11.7010, lng: 75.5340 },
  { city: "Yanam", state: "Puducherry", lat: 16.7330, lng: 82.2130 },
  { city: "Port Blair", state: "Andaman and Nicobar Islands", lat: 11.6234, lng: 92.7265 },
  { city: "Kavaratti", state: "Lakshadweep", lat: 10.5626, lng: 72.6369 },
  { city: "Daman", state: "Daman and Diu", lat: 20.3974, lng: 72.8328 },
  { city: "Diu", state: "Daman and Diu", lat: 20.7144, lng: 70.9874 },
  { city: "Dadra", state: "Dadra and Nagar Haveli", lat: 20.1809, lng: 73.0169 },
  { city: "Silvassa", state: "Dadra and Nagar Haveli", lat: 20.2766, lng: 73.0145 },
];
